import React from "react";
import { Charges } from ".";
import { DisplayBox, Loading } from "../../components";
import { ApiHelper, DateHelper, InvoiceInterface } from "../../helpers";

interface Props {

}

export const Invoices: React.FC<Props> = props => {

  const [invoices, setInvoices] = React.useState<InvoiceInterface[]>(null);
  const [selectedInvoice, setSelectedInvoice] = React.useState<InvoiceInterface>(null);


  const init = () => {
    ApiHelper.get("/invoices").then((data: InvoiceInterface[]) => setInvoices(data));
  }

  React.useEffect(init, [])


  const getTable = () => {
    if (invoices === null) return <Loading />
    else {
      if (invoices.length === 0) return <p>There are no invoices yet</p>
      else {
        const formatter = Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });

        const rows: JSX.Element[] = [];
        invoices.forEach(i => {
          const invoice = i;
          rows.push(<tr>
            <td>
              <a href="about:blank" onClick={(e) => { e.preventDefault(); setSelectedInvoice(invoice) }}>
                {DateHelper.formatDateTime(DateHelper.convertToDate(i.endDate), "MMMM yyyy")}
              </a>
            </td>
            <td>{formatter.format(i.amount)}</td>
            <td>{i.status}</td>
          </tr>)

        });
        return (<table className="table table-sm table-striped">
          <thead>
            <tr><th>Month</th><th>Amount</th><th>Status</th></tr>
          </thead>
          <tbody>{rows}</tbody>
        </table>)
      }
    }
  }

  const getInvoiceDetails = () => {
    if (selectedInvoice) return <Charges invoice={selectedInvoice} onClose={() => setSelectedInvoice(null)} />
  }

  return (
    <>
      {getInvoiceDetails()}
      <DisplayBox headerText="Invoices" headerIcon="fas fa-credit-card" >
        {getTable()}
      </DisplayBox>
    </>
  );
};